import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData, getInputParams } from '../CustomUtils'
import { CLAIM_FILE_EXPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import ReportGrid from '../ReportGrid.js'
import { getTenant } from '../../../utils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'

const CLAIM_FILE_EXPORT = gql(CLAIM_FILE_EXPORT_QUERY)

export default function ClaimFileReport({ location }) {
  console.log('ClaimFileReport rendered:', location)

  const inputs = getInputParams(location)
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  console.log('ClaimFileExport results: ', results)

  useEffect(() => {
    getData(location, CLAIM_FILE_EXPORT, 'claimFileExport', setResults, setGraphQLErrors)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/Asbestos/claimFileExport/claim_file_report.csv?inputs=${JSON.stringify(inputs)}`
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title='Hart Report' parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} />
          </tbody>
        </Table>
      </div>
    )
  }
}